const DI = window.DI;

/*  Copy pasted from dialog insight, only the script part */
DI.Forms.Optin.Dom.onReady(function () {
  DI.Forms.Optin.Client.InitOptinForm({
    formIdent: 'DIForm_786_21727',
    culture: 'fr-CA',
    idBaseDiv: 'divForm_DIForm_786_21727',
    recaptchaSiteKey: '',
    fields: [
      {
        name: 'f_EMail',
        lbl: 'Courriel',
        id: 'DIField_21727_f_EMail',
        validators: ['required', 'email'],
      },
      {
        name: 'f_FirstName',
        lbl: 'Prénom',
        id: 'DIField_21727_f_FirstName',
        validators: [],
      },
      {
        name: 'f_LastName',
        lbl: 'Nom',
        id: 'DIField_21727_f_LastName',
        validators: [],
      },
      {
        name: 'optin_Formulaire_site_web',
        lbl: 'Je consens à recevoir des communications de l\u0027Ordre des dentistes du Québec',
        id: 'DIField_21727_optin_Formulaire_site_web',
        validators: [],
        inputType: 'checkbox',
      },
    ],
    fieldValues: { optin_Formulaire_site_web: 0 },
    errorMessages: {
      general: 'Erreur dans le formulaire.',
      required: 'Le champ {0} est requis.',
      dataType: 'Type de donnée invalide pour le champ {0}.',
      min: 'La valeur minimum pour le champ {0} est {1}.',
      max: 'La valeur maximum pour le champ {0} est {1}.',
      interval: 'La valeur pour le champ {0} doit être entre {1} et {2}.',
      inputMask:
        'La valeur pour le champ {0} ne respecte pas le format de saisie.',
      updateDupeKey:
        'La mise à jour n’a pas pu être effectuée car cet identifiant existe déjà.',
      checkInlineErrors: 'Veuillez corriger les erreurs ci-dessous.',
    },
    idSuccessDiv: 'divForm_DIForm_786_21727_success',
    mode: DI.Forms.Optin.Client.EnumOptinMode.Optin,
    url: '//app.dialoginsight.com/A/WF.ashx',
    idWorkflow: 17964,
    wfKey: 'U2btl6',
    nodeKey: 'Optin',
    visible: true,
  });
});

/*  end Copy pasted from dialog insight, only the script part  */

/* Custom script */

const textInputs = document.querySelectorAll(
  'input[type=text].DialogInsightFormInput'
);

textInputs.forEach((input) => {
  input.addEventListener('focus', function () {
    input.closest('.DialogInsightFormRow').classList.add('focused');
  });
  input.addEventListener('blur', function () {
    if (input.value.length === 0) {
      input.closest('.DialogInsightFormRow').classList.remove('focused');
    }
  });
});
